import type { AssetCreateDto, AssetDto, AssetUpdateDto, AssetWithNavigationPropertiesDto, GetAssetsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  apiName = 'Inventory';

  create = (input: AssetCreateDto) =>
    this.restService.request<any, AssetDto>({
      method: 'POST',
      url: '/api/inventory/assets',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/assets/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetDto>({
      method: 'GET',
      url: `/api/inventory/assets/${id}`,
    },
    { apiName: this.apiName });

  getAssetModelLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/asset-model-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getAssetStatusLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/asset-status-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getAssetTypeLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/asset-type-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getInventoryLocationLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/inventory-location-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getLegalDocumentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/legal-document-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetAssetsInput) =>
    this.restService.request<any, PagedResultDto<AssetWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/assets',
      params: { filterText: input.filterText, name: input.name, description: input.description, brand: input.brand, invoiceData: input.invoiceData, purshaseDateMin: input.purshaseDateMin, purshaseDateMax: input.purshaseDateMax, garrantyExpirationDateMin: input.garrantyExpirationDateMin, garrantyExpirationDateMax: input.garrantyExpirationDateMax, serialNumber: input.serialNumber, internalCode: input.internalCode, assetTypeId: input.assetTypeId, assetStatusId: input.assetStatusId, assetModelId: input.assetModelId, providerId: input.providerId, inventoryLocationId: input.inventoryLocationId, legalDocumentId: input.legalDocumentId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getProviderLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/assets/provider-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, AssetWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/assets/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetUpdateDto) =>
    this.restService.request<any, AssetDto>({
      method: 'PUT',
      url: `/api/inventory/assets/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
